import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { DEFAULT_LANGUAGE } from '../utils/constants';

export const useLanguage = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lang: 'ar' | 'en') => {
    void i18n.changeLanguage(lang);
    // Update HTML dir attribute for RTL/LTR
    document.documentElement.setAttribute('dir', lang === 'ar' ? 'rtl' : 'ltr');
    document.documentElement.setAttribute('lang', lang);
    
    // Store preference
    localStorage.setItem('i18nextLng', lang);
  };

  const currentLanguage = (i18n.language || DEFAULT_LANGUAGE) as 'ar' | 'en';
  const isRTL = currentLanguage === 'ar';

  useEffect(() => {
    // Set initial direction on mount
    const lang = (i18n.language || DEFAULT_LANGUAGE) as 'ar' | 'en';
    document.documentElement.setAttribute('dir', lang === 'ar' ? 'rtl' : 'ltr');
    document.documentElement.setAttribute('lang', lang);
  }, [i18n.language]);

  return {
    currentLanguage,
    isRTL,
    changeLanguage,
    t: i18n.t,
  };
};

